<template>
  <div class="left-right-content">
    <div class="left">
      <slot></slot>
    </div>
    <div class="right" :style="'width:' + rightWidth">
      <slot name="sub"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "LeftRightContent",
  props: {
    rightWidth: {
      type: String,
      default: "356px"
    }
  }
};
</script>
<style scoped lang="scss">
.left-right-content {
  display: flex;
  height: 100%;
  .left {
    flex: 1;
    padding: 20px;
    height: 100%;
    background-color: #fff;
  }
  .right {
    /*height: 100%;*/ //黏性布局有问题
  }
}
</style>
